import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import MultipleFileInput from '@/components/Ui/MultipleFileInput'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'
import moment from 'moment';

export default {
  name: 'File',
  components: {
    Loading,
    MultipleFileInput
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: false,
      processing: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'spAppMstId',
        'serviceTermsFileName',
        'serviceTermsFileUpdatedAt',
      ],
      tableData: [],
      tableOptions: {
        headings: {
          spAppMstId: 'ID',
          serviceTermsFileName: 'ファイル名',
          serviceTermsFileUpdatedAt: '登録日',
        },
        columnsClasses: {
          spAppMstId: 'wp-5',
          serviceTermsFileName: '',
          serviceTermsFileUpdatedAt: 'wp-25',
        },
        sortable: [
          // 'spAppMstId',
          // 'serviceTermsFileName',
          // 'serviceTermsFileUpdatedAt',
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 入力フォーム
      inpFile: null
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.spAppMst.categoryName,
      spAppMstModel: state => state.spAppMst.spAppMstModel,
      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // validate
    inpFileIsValid () {
      return Validator.validFile(this.inpFile)
    },
    formIsValid () {
      return this.inpFileIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'spAppMst/loadModel'
    }),
    ...mapMutations({
      setInputValue: 'spAppMst/setInputValue',
    }),

    init () {
      this.loading = false

      //TODO
      let spAppMstParams = {}

      // データ読出し
      this.loadModel({
        spAppMstParams: spAppMstParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.spAppMstModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'serviceTermsFileName':
          return '<a href="' + props.row.serviceTermsFileUrl + '" target="_blank">' + value + '</a>'
        case 'serviceTermsFileUpdatedAt':
          return moment(value).format('YYYY-MM-DD HH:mm')
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    // ファイル登録
    changeFile ({index, file}) {
      this.inpFile = file
    },
    confirmData() {
      this.showConfirm({
        key: 'register',
        title: '',
        body: 'この内容で' + this.categoryName + 'を登録しますか？'
      })
    },
    postData () {
      this.processing = true

      let parameters = {
        request: {
          serviceTermsFile: this.inpFile
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['spAppMst'],
        ['v1SpAppMstPost'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '新しい' + this.categoryName + 'の登録',
              body: this.categoryName + 'を登録しました。'
            })
            this.inpFile = null

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    deleteData () {
      this.deleteTargetId = null
    }
  }
}